<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="点位类型" class="EL-Form-Item">
            <el-select v-model="mainSearch.spCode" clearable="clearable">
              <el-option label="巷道" value="AutoArea"></el-option>
              <el-option label="备料区" value="MatSpare"></el-option>
              <el-option label="退料区" value="ReturnArea"></el-option>
              <el-option label="仓库成品区" value="CKPacking"></el-option>
              <el-option label="成品包装区" value="Packing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="点位编号" class="EL-Form-Item">
            <el-input
              placeholder="请输入"
              v-model="mainSearch.prCode"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="状态" class="EL-Form-Item">
            <el-select v-model="mainSearch.occupyFlag" clearable="clearable">
              <el-option label="占用" value="1"></el-option>
              <el-option label="空闲" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :lg="9" :xl="9">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getSysPointRouterAll()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="点位">
        <el-button
          v-authority="'BACK_MENU5_M11_B1'"
          class="btn-t-edit"
          @click="(add_or_edit = true), (editBoxShow = true)"
          >新增</el-button
        >
        <el-button
          v-authority="'BACK_MENU5_M11_B4'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getSysPointRouterAll"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
      >
        <el-table-column prop="spCode" label="点位类型">
          <template slot-scope="scope">
            <span v-if="scope.row.spCode == 'AutoArea'">巷道</span>
            <span v-if="scope.row.spCode == 'MatSpare'">备料区</span>
            <span v-if="scope.row.spCode == 'ReturnArea'">退料区</span>
            <span v-if="scope.row.spCode == 'CKPacking'">仓库成品区</span>
            <span v-if="scope.row.spCode == 'Packing'">成品包装区</span>
          </template>
        </el-table-column>
        <el-table-column prop="prCode" label="点位编号" />
        <el-table-column prop="agvCode" label="AGV呼叫站点" />
        <!-- <el-table-column prop="prCode" label="呼叫站点" /> -->
        <el-table-column prop="occupyFlag" label="是否占用">
          <template slot-scope="scope">
            <span v-if="scope.row.occupyFlag == true">占用</span>
            <span v-if="scope.row.occupyFlag == false">空闲</span>
          </template>
        </el-table-column>
        <el-table-column prop="prArea" label="工作区" />
        <el-table-column prop="prGroup" label="仓库">
          <template slot-scope="scope">
            <span v-if="scope.row.prGroup == 'A'">一期</span>
            <span v-if="scope.row.prGroup == 'C'">二期</span>
            <span v-if="scope.row.prGroup == 'D'">三期</span>
            <span v-if="scope.row.prGroup == 'E'">四期</span>
          </template>
        </el-table-column>
        <el-table-column prop="prSort" label="排序" />
        <el-table-column prop="waitPoint" label="等待点" />
        <el-table-column prop="prCntrTyp" label="容器类型" />
        <el-table-column prop="prBoxType" label="箱体类型" />
        <el-table-column prop="channelCode" label="巷道编号" />
        <el-table-column prop="boxHeight" label="箱体高度" />
        <el-table-column prop="delete_flag" label="点位状态">
          <template slot-scope="scope">
            <span v-if="!scope.row.delete_flag">启用</span>
            <span v-if="scope.row.delete_flag">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" />
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              v-authority="'BACK_MENU5_M11_B2'"
              size="mini"
              type="primary"
              @click="updateRow(scope.row)"
              plain
              icon="el-icon-edit-outline"
            />
            <el-button
              v-authority="'BACK_MENU5_M11_B4'"
              type="danger"
              @click="deleteRow(scope.row.prId)"
              size="mini"
              plain
              icon="el-icon-delete"
            />
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 新增&&编辑框 -->
    <el-dialog
      :title="add_or_edit ? '新增' : '编辑'"
      :close-on-click-modal="false"
      :visible.sync="editBoxShow"
      :style="$popups.popups(0.5, 0.45)"
      class="fromDialog"
      :model="mainObj"
      @open="open"
    >
      <span class="formClass">
        <el-form
          label-width="100px"
          :model="mainObj"
          :rules="rules"
          ref="mainObj"
        >
          <el-col :lg="8" :xl="8">
            <el-form-item label="点位类型" prop="spCode" class="EL-Form-Item">
              <el-select
                v-model="mainObj.spCode"
                placeholder="请选择"
                clearable="clearable"
              >
                <el-option label="巷道" value="AutoArea"></el-option>
                <el-option label="备料区" value="MatSpare"></el-option>
                <el-option label="退料区" value="ReturnArea"></el-option>
                <el-option label="仓库成品区" value="CKPacking"></el-option>
                <el-option label="成品包装区" value="Packing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="点位编号" prop="prCode" class="EL-Form-Item">
              <el-input
                v-model="mainObj.prCode"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="AGV呼叫站点"
              prop="agvCode"
              class="EL-Form-Item"
            >
              <el-input
                v-model="mainObj.agvCode"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="是否占用"
              prop="occupyFlag"
              class="EL-Form-Item"
            >
              <el-select
                v-model="mainObj.occupyFlag"
                placeholder="请选择"
                clearable="clearable"
              >
                <el-option label="占用" value="true"></el-option>
                <el-option label="空闲" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="工作区" prop="prArea" class="EL-Form-Item">
              <el-input
                v-model="mainObj.prArea"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="排序" prop="prSort" class="EL-Form-Item">
              <el-input
                v-model="mainObj.prSort"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="等待点" prop="prSort" class="EL-Form-Item">
              <el-input
                v-model="mainObj.waitPoint"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="仓库" prop="prGroup" class="EL-Form-Item">
              <el-select
                v-model="mainObj.prGroup"
                placeholder="请选择"
                clearable="clearable"
              >
                <el-option label="一期" value="A"></el-option>
                <el-option label="二期" value="C"></el-option>
                <el-option label="C区" value="D"></el-option>
                <!-- <el-option label="四期" value="E"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="容器类型"
              prop="prCntrTyp"
              class="EL-Form-Item"
            >
              <el-input
                v-model="mainObj.prCntrTyp"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="箱体类型"
              prop="prBoxType"
              class="EL-Form-Item"
            >
              <el-input
                v-model="mainObj.prBoxType"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="巷道编号"
              prop="channelCode"
              class="EL-Form-Item"
            >
              <el-input
                v-model="mainObj.channelCode"
                placeholder="请输入"
                clearable="clearable"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="箱体高度"
              prop="boxHeight"
              class="EL-Form-Item"
            >
              <el-input
                type="number"
                v-model="mainObj.boxHeight"
                onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item
              label="点位状态"
              prop="delete_flag"
              class="EL-Form-Item"
            >
              <el-select
                v-model="mainObj.delete_flag"
                placeholder="请选择"
                :clearable="false"
              >
                <el-option label="启用" :value="false"></el-option>
                <el-option label="停用" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer footer-bottom">
        <el-button size="small" type="info" @click="editBoxShow = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
          新 增
        </el-button>
        <el-button size="small" type="primary" v-else @click="editRow">
          修 改
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Warehouse",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      rules: {
        spCode: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ],
        prCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            max: 20,
            message: "点位编号长度不能超过20位"
          }
        ],
        agvCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            max: 50,
            message: "AGV呼叫站点长度不能超过50位"
          }
        ],
        occupyFlag: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ],
        prArea: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            max: 50,
            message: "工作区长度不能超过50位"
          }
        ],
        prGroup: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ],
        prCntrTyp: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            max: 20,
            message: "容器类型长度不能超过20位"
          }
        ],
        // prBoxType: [{
        //     required: true,
        //     message: "请输入",
        //     trigger: "blur",
        // }, ],
        // channelCode: [{
        //     required: true,
        //     message: "请输入",
        //     trigger: "blur",
        // }, ],
        boxHeight: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
          // {
          //     max: 18,
          //     message: "箱体高度长度不能超过18位",
          // }
        ],
        prBoxType: [
          {
            max: 10,
            message: "箱体类型长度不能超过10位"
          }
        ],
        channelCode: [
          {
            max: 10,
            message: "巷道编号长度不能超过10位"
          }
        ]
      },
      showRoleBox: true,
      add_or_edit: Boolean, //新增|编辑
      loading: 0, //加载中
      editBoxShow: false, //编辑框
      dialogFormVisible: false,
      formLabelWidth: "140px", // 对话框大小
      tableHeight: 0, //表格高度
      testValue: 1,
      mainObj: {
        fcCode: localStorage.getItem("fcCode") || ""
      },
      mainSearch: {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        spCode: "",
        prCode: "",
        occupyFlag: ""
      },
      tableTotal: 0,
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 20,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        }
      },
      fcode: localStorage.getItem("fcCode") || "",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.changeSysPointRouterAll(newVal);
        }, 1000);
      },
      deep: true
    }
  },
  methods: {
    /**
     * 打开修改窗口
     */
    updateRow(row) {
      this.mainObj = JSON.parse(JSON.stringify(row));
      this.mainObj.occupyFlag = row.occupyFlag + "";
      this.add_or_edit = false;
      this.editBoxShow = true;
    },
    /**
     * 重置页码
     */
    changeSysPointRouterAll(newVal) {
      this.mainData.nowPage = 1;
      this.getSysPointRouterAll(newVal);
    },
    //获取数据
    getSysPointRouterAll() {
      this.$http
        .request({
          url: "/api/sysPointRouter/getSysPointRouterAllMsg",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage,
            pageSize: this.mainData.pageSize,
            fcCode: this.mainSearch.fcCode,
            spCode: this.mainSearch.spCode,
            prCode: this.mainSearch.prCode,
            occupyFlag: this.mainSearch.occupyFlag
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.mainData.data = resp.data.list || [];
            this.mainData.total = resp.data.total;
          }
        })
        .catch(error => {
          this.loading++;
        });
    },

    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate(valid => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },
    //框打开
    open() {
      if (this.add_or_edit) {
        //新增
        this.mainObj = JSON.parse(JSON.stringify({}));
      } else {
        this.getSysPointRouterAll();
      }
    },
    //新增
    add() {
      this.mainObj.fcCode = localStorage.getItem("fcCode");
      if (this.submitForm("mainObj")) {
        this.$http
          .request({
            url: "/api/sysPointRouter/insertSysPointRouter",
            method: "POST",
            showLoading: true,
            data: this.mainObj
          })
          .then(resp => {
            if (resp.status == 100) {
              this.$notify({
                title: "成功",
                message: "新增成功！",
                type: "success"
              });
              this.logRemarks = "warehouse：点位新增成功";
            } else {
              this.$notify.error({
                title: "失败",
                message: resp.message
              });
              this.logRemarks = "warehouse：点位新增失败";
            }
            this.logContent = "prCode" + this.mainObj.prCode;
            this.systemLog();
            this.editBoxShow = false;
            this.getSysPointRouterAll();
          })
          .catch(error => {
            this.$notify.error({
              title: "失败",
              message: "调用失败"
            });
          });
      }
    },
    //编辑
    editRow() {
      if (this.submitForm("mainObj")) {
        this.$http
          .request({
            url: "/api/sysPointRouter/updateSysPointRouter",
            method: "POST",
            showLoading: true,
            data: this.mainObj
          })
          .then(resp => {
            if (resp.status == 100) {
              this.$notify({
                title: "成功",
                message: "修改成功！",
                type: "success"
              });
              this.logRemarks = "warehouse：点位修改成功";
            } else {
              this.$notify.error({
                title: "失败",
                message: resp.message
              });
              this.logRemarks = "warehouse：点位修改失败";
            }
            this.logContent = "prCode" + this.mainObj.prCode;
            this.systemLog();
            this.editBoxShow = false;
            this.getSysPointRouterAll();
          })
          .catch(error => {
            this.$notify.error({
              title: "失败",
              message: "调用失败"
            });
          });
      }
    },
    //删除
    deleteRow(prId) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/sysPointRouter/deleteSysPointRouter",
              method: "DELETE",
              showLoading: true,
              params: {
                prId: prId
              }
            })
            .then(resp => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "删除成功！",
                  type: "success"
                });
                this.logRemarks = "warehouse：点位删除成功";
              } else {
                this.$notify.error({
                  title: "失败",
                  message: "删除失败"
                });
                this.logRemarks = "warehouse：点位删除失败";
              }
              this.logContent = "prId" + prId;
              this.systemLog();
              this.getSysPointRouterAll();
            })
            .catch(error => {
              this.$notify.error({
                title: "失败",
                message: "调用失败"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //重置
    resetData() {
      this.mainSearch = {
        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
        spCode: "",
        prCode: "",
        occupyFlag: ""
      };
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        fcCode: this.mainSearch.fcCode,
        spCode: this.mainSearch.spCode,
        prCode: this.mainSearch.prCode,
        occupyFlag: this.mainSearch.occupyFlag,
        pageNum: 1,
        pageSize: 999999
      };

      this.$http
        .request({
          url: "/api/sysPointRouter/getSysPointRouterAllMsg",
          method: "GET",
          showLoading: true,
          params: paramsObj
        })
        .then(resp => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败"
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then(excel => {
        list.forEach(function(c) {
          if (c.spCode == "AutoArea") {
            c["spCode"] = "巷道";
          } else if (c.spCode == "MatSpare") {
            c["spCode"] = "备料区";
          } else if (c.spCode == "ReturnArea") {
            c["spCode"] = "退料区";
          }

          if (c.occupyFlag == true) {
            c["occupyFlag"] = "占用";
          } else if (c.occupyFlag == false) {
            c["occupyFlag"] = "空闲";
          }

          if (c.prGroup == "A") {
            c["prGroup"] = "一期";
          } else if (c.prGroup == "C") {
            c["prGroup"] = "二期";
          }
        });
        const tHeader = [
          "点位类型",
          "点位编号",
          "AGV呼叫站点",
          "是否占用",
          "工作区",
          "仓库",
          "排序",
          "等待点",
          "容器类型",
          "箱体类型",
          "巷道编号",
          "箱体高度",
          "点位状态",
          "创建时间"
        ];
        const filterVal = [
          "spCode",
          "prCode",
          "agvCode",
          "occupyFlag",
          "prArea",
          "prGroup",
          "prSort",
          "waitPoint",
          "prCntrTyp",
          "prBoxType",
          "channelCode",
          "boxHeight",
          "delete_flag",
          "createTime"
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "点位数据"
        });
        this.logContent = "导出";
        this.logRemarks = "sys_warehouse：导出点位数据";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "通道主数据",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || ""
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData
        })
        .then(resp => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch(error => {});
    }
  },
  activated() {
    /* 获取首页的数据 */
    this.getSysPointRouterAll();
  }
};
</script>

<style scoped></style>
